import * as selectors from './selectors';
import * as constants from './constants';
import * as actionCreators from './action-creators';
import {reducer} from './reducer';

export const documentsTable = {
    selectors,
    constants,
    actionCreators,
    reducer,
};
